import { render, staticRenderFns } from "./ComponentToday.vue?vue&type=template&id=0ad15c0a"
import script from "./ComponentToday.vue?vue&type=script&lang=js"
export * from "./ComponentToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports